"use client";
import React from "react";
import { Box, Button, Carousel } from "@quintoandar-tokko/jopijs";
import { useSelector, useDispatch } from "react-redux";
import style from "./gallery.module.scss";
import Trans from "@/components/shared/Trans";
import translations from "../../FichaInfo.trans.json";
import { setIsImagesEdition } from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import Skeleton from "../../skelenton/Skeleton";

export default function Gallery() {
  const dispatch = useDispatch();
  const state = useSelector((ste) => ste.FichaInfoSlice);
  const { showData, isEdition, loading } = state;
  const picturesData = state[isEdition ? "edited_data" : showData];
  const { pictures, videos } = picturesData;
  const { images, blueprints, front_cover_image } = pictures;

  const handleCoverImg = (type) => {
    if (!front_cover_image) {
      return false;
    }
    if (type === "img") {
      return !front_cover_image.is_blueprint && front_cover_image.url;
    }
    return front_cover_image.is_blueprint && front_cover_image.url;
  };

  const SkeletonsGallery = () => (
    <Box className={style.gallerySkeletonsContainer}>
      <Box className={style.mainImageContainer}>
        <Skeleton height="100%" width="100%" borderRadius={12} />
      </Box>
      <Box className={style.follwingSkeletonImagesContainer}>
        {Array(6)
          .fill()
          .map((el, index) => (
            <Skeleton
              key={`key${el}${index}`}
              className={style.skeletonItem}
              borderRadius={12}
            />
          ))}
      </Box>
    </Box>
  );

  if (loading) return <SkeletonsGallery />;

  const EditImageBtn = () => (
    <Button
      variant={["primary"]}
      borderRadius="8px"
      className={style.editGalleryButton}
      data-testid="to-edit-images"
      onClick={() => {
        dispatch(setIsImagesEdition(true));
      }}
    >
      {Trans(translations, "EditImages")}
    </Button>
  );

  const carouselTabs = {
    videos: Trans(translations, 'Videos'),
    video360: Trans(translations, 'Video360'),
    photos: Trans(translations, 'Photos'),
    bluePrints: Trans(translations, 'Blueprints'),
  };

  return (
    <Box className={style.galleryContainer}>
      <Carousel
        frontCoverImg={handleCoverImg("img")}
        frontCoverBlueprints={handleCoverImg("blueprint")}
        images={images}
        planos={blueprints}
        video={videos.normal}
        video360={videos["360"]}
        otherButton={isEdition ? <EditImageBtn /> : false}
        tabTextsDict={carouselTabs}
      />
    </Box>
  );
}
